export enum CommodityTankConstraintOption {
  BLEND_RATIO = 'blendRatio',
  PROPERTIES = 'properties',
}
